/* 轻量操作cookie */
export function addCookie(
  name: string,
  value: string,
  domain: string | undefined,
  path: string | undefined,
  expireMinutes: number,
) {
  let val = value;
  if (value.indexOf(';') !== -1) {
    val = escape(value);
  }
  let cookieString = `${name}=${val}`;
  if (domain) {
    cookieString += `; domain=${domain}`;
  }
  if (path) {
    cookieString += `; path=${path}`;
  }
  // 判断是否设置过期时间
  if (expireMinutes > 0) {
    const date = new Date();
    date.setTime(date.getTime() + expireMinutes * 60 * 1000);
    cookieString += `;expires=${(date as any).toGMTString()}`;
  }
  document.cookie = cookieString;
}

export function getCookie(cookie_name: string) {
  const results = document.cookie.match(`(^|;) ?${cookie_name}=([^;]*)(;|$)`);
  if (results) {
    return unescape(results[2]);
  }
  return null;
}
